import React from "react"

import FormattedMessage from "@irati/utils/lang"
import {PaymentCurrencyType} from "@irati/types"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import {Body} from "@irati/ui/src/Typography"
import authentication from "@irati/auth"
import {getDomain} from "@irati/utils/links"
import {FormatMessage} from "@irati/utils/lang/types"

import {ALL_TEAMS} from "../../../../Reporting/Region"

export const getFlexiPerksTitle = (hasPerksInReport: boolean) => {
  return hasPerksInReport
    ? "admin.components.dashboard.reporting.costOfLiving.modal.widgets.flexiPerks.title"
    : "admin.components.dashboard.reporting.costOfLiving.modal.widgets.flexiPerks.platform.title"
}

export const getFlexiPerksText = (hasPerksInReport: boolean) => {
  return hasPerksInReport
    ? "admin.components.dashboard.reporting.costOfLiving.modal.widgets.flexiPerks.text"
    : "admin.components.dashboard.reporting.costOfLiving.modal.widgets.flexiPerks.platform.text"
}

export const getPerksTitle = (hasPerksInReport: boolean) => {
  return hasPerksInReport
    ? "admin.components.dashboard.reporting.costOfLiving.modal.widgets.perks.title"
    : "admin.components.dashboard.reporting.costOfLiving.modal.widgets.perks.platform.title"
}

export const getPerksText = (hasPerksInReport: boolean) => {
  return hasPerksInReport
    ? "admin.components.dashboard.reporting.costOfLiving.modal.widgets.perks.text"
    : "admin.components.dashboard.reporting.costOfLiving.modal.widgets.perks.platform.text"
}

export const getEncourageText = (unspentFlexiPoints: number, currencyCode: PaymentCurrencyType) => {
  if (unspentFlexiPoints > 0) {
    return (
      <FormattedMessage
        id="admin.components.dashboard.reporting.costOfLiving.modal.shareText"
        values={{
          bold: (
            <Body weight="bold" display="inline">
              {formatCurrency({currencyCode, value: unspentFlexiPoints, isCents: false})}
            </Body>
          )
        }}
      />
    )
  }
  return <FormattedMessage id="admin.components.dashboard.reporting.costOfLiving.modal.flexiPerks.body1" />
}

export const getShareText = (isFlexi: boolean) => {
  if (isFlexi) {
    return "admin.components.dashboard.reporting.costOfLiving.modal.flexiPerks.shareText"
  }
  return "admin.components.dashboard.reporting.costOfLiving.modal.perks.shareText"
}

export const getButtonText = (unspentFlexiPoints: number, currencyCode: PaymentCurrencyType) => {
  if (unspentFlexiPoints > 0) {
    return (
      <FormattedMessage
        id="admin.components.dashboard.reporting.costOfLiving.unlock.buttonText"
        values={{unspent: formatCurrency({currencyCode, value: unspentFlexiPoints, isCents: false})}}
      />
    )
  }
  return "admin.components.dashboard.reporting.costOfLiving.buttonText"
}

export const getBoldCompaniesText = () => {
  return (
    <Body weight="bold" display="inline">
      <FormattedMessage id="admin.components.dashboard.reporting.costOfLiving.modal.widgets.companies" />
    </Body>
  )
}

export const getTopPerksText = (
  showNewPerks: boolean,
  hasPerksInReport: boolean,
  hasFlexiPerks: boolean,
  regionId: string,
  region: string
) => {
  let text = ""
  if (showNewPerks) {
    if (regionId !== ALL_TEAMS) {
      text = "admin.components.dashboard.reporting.costOfLiving.modal.latestPerks.region"
    } else {
      text = "admin.components.dashboard.reporting.costOfLiving.modal.latestPerks.all"
    }
  } else if (hasFlexiPerks) {
    if (hasPerksInReport) {
      if (regionId !== ALL_TEAMS) {
        text = "admin.components.dashboard.reporting.costOfLiving.modal.flexiPerks.topFlexiPerksRegion"
      } else {
        text = "admin.components.dashboard.reporting.costOfLiving.modal.flexiPerks.topFlexiPerks"
      }
    } else {
      if (regionId !== ALL_TEAMS) {
        text = "admin.components.dashboard.reporting.costOfLiving.modal.flexiPerks.platform.topFlexiPerksRegion"
      } else {
        text = "admin.components.dashboard.reporting.costOfLiving.modal.flexiPerks.platform.topFlexiPerks"
      }
    }
  } else {
    if (hasPerksInReport) {
      if (regionId !== ALL_TEAMS) {
        text = "admin.components.dashboard.reporting.costOfLiving.modal.flexiPerks.topPerksRegion"
      } else {
        text = "admin.components.dashboard.reporting.costOfLiving.modal.flexiPerks.topPerks"
      }
    } else {
      if (regionId !== ALL_TEAMS) {
        text = "admin.components.dashboard.reporting.costOfLiving.modal.popularPerks.region"
      } else {
        text = "admin.components.dashboard.reporting.costOfLiving.modal.popularPerks.all"
      }
    }
  }

  return <FormattedMessage id={text} values={{businessName: authentication.business().businessName, region}} />
}

export const getTopPerksBodyText = (hasFlexiPerks: boolean, region: string) => {
  const text = hasFlexiPerks
    ? "admin.components.dashboard.reporting.costOfLiving.modal.flexiPerks.body3"
    : "admin.components.dashboard.reporting.costOfLiving.modal.perks.body3"
  return <FormattedMessage id={text} values={{businessName: authentication.business().businessName, region}} />
}

export const getCopyText = (region: string, regionId: string, perks: any, formatMessage: FormatMessage, entry?: string) => {
  const text =
    regionId === ALL_TEAMS
      ? formatMessage({id: "admin.components.dashboard.reporting.costOfLiving.perksModal.copyToClipboardPerks"})
      : formatMessage({id: "admin.components.dashboard.reporting.costOfLiving.perksModal.copyToClipboardRegionPerks"}, {region})
  const dealsText = perks.map((perk, i) => {
    return `${formatMessage(
      {id: "admin.components.dashboard.reporting.costOfLiving.perksModal.copyToClipboardPerk"},
      {
        position: i + 1,
        dealName: perk.brandName,
        dealUrl: `${getDomain(authentication.business().subdomain)}/perks/info/${perk.urlSlug}${entry ? `?entry=${entry}` : ""}`
      }
    )}\n\n`
  })
  const linkText = formatMessage(
    {id: "admin.components.dashboard.reporting.costOfLiving.perksModal.copyToClipboardLink"},
    {link: authentication.business().subdomain}
  )
  return `${text}\n\n${dealsText.join("")}${linkText}`
}
